import React from 'react'
import { Spacer, ButtonGroup } from '@fedsim/components'

import LoadSave from 'components/load-save'
import TitleBar from 'components/title'
import { ResetAll } from 'pages/settings/index'

import Instructions from './instructions'

export function Layout({
  children = null
}) {
  return (
    <>
      <TitleBar title={"Welcome to FedSim X"}>
        <ButtonGroup>
        <LoadSave />
          <ResetAll />
        </ButtonGroup>
      </TitleBar>
      <Instructions />
      <Spacer />
      {children}
    </>
  )
}

export default Layout
